module.exports = __webpack_public_path__ + "media/Audiobook_English.1cc3bc18.mp3";